import React, { useState } from "react";

import { Button, Typography } from "clearsense-ui/components";
import { Plus } from "components/Common/clearsense-ui/icons";
import ExploreContainer from "components/Common/ExploreContainer";
import PermissibleWrapper from "components/Common/PermissibleWrapper";
import { useUserState } from "contexts/user";
import { getPermissions } from "utils/roleBasedAccess";

import Crosswalk from "./Crosswalk";
import NewCrosswalk from "./NewCrosswalk";

import SummaryCard from "../SummaryCard";

const Crosswalks = ({
  features,
  referenceSource,
  fetchReferenceSourceData,
}) => {
  const user = useUserState();
  const userPermissions = getPermissions(features, user?.role);

  const [isNewCrosswalkOpen, setIsNewCrosswalkOpen] = useState(false);

  return (
    <ExploreContainer>
      <div className="flex justify-between mb-4">
        <Typography style="h3" type="semibold">
          Crosswalks in {referenceSource?.name}
        </Typography>
        <PermissibleWrapper
          currentPermissions={userPermissions}
          acceptablePermissions="create"
        >
          <Button
            label="Create Crosswalk"
            icon={Plus}
            onClick={() => setIsNewCrosswalkOpen(true)}
            data-cy="new-crosswalk-button"
            data-testid="create-button"
          />
        </PermissibleWrapper>
        <NewCrosswalk
          isPaneOpen={isNewCrosswalkOpen}
          setIsPaneOpen={setIsNewCrosswalkOpen}
        />
      </div>
      <SummaryCard referenceSource={referenceSource} />
      <Crosswalk
        referenceSource={referenceSource}
        features={features}
        title={"Crosswalk In - List"}
        fetchReferenceSourceData={fetchReferenceSourceData}
      />
      <Crosswalk
        referenceSource={referenceSource}
        features={features}
        title={"Crosswalk Out - List"}
        fetchReferenceSourceData={fetchReferenceSourceData}
      />
    </ExploreContainer>
  );
};

export default Crosswalks;
